import InstagramIcon from "@mui/icons-material/Instagram";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import { Button, Card, CardActionArea, CardContent, CardHeader, CardMedia, Chip, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
    React.useEffect(() => {
        document.title = "Wake Students";
    }, []);
    return (
        <>
            <Card>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                    <img style={{ padding: "16px", height: "4rem" }} src="/circleLogo.svg" alt="Wake Students Logo" />
                    <CardHeader title={<>Wake Students<Chip label="Preview" color="primary" style={{ marginLeft: ".2rem" }} /></>} subheader="An Ian Steiger Project" />
                </div>

            </Card>
            <Grid container spacing={2} justifyContent="center" style={{ paddingTop: "24px" }}>
                <Grid item xs={12}>
                    <Card>
                        <CardActionArea style={{ height: "100%" }} component={Link} to="/games">
                            <CardMedia style={{ backgroundImage: "linear-gradient(45deg,#40d1ff,#00ffae)", display: "flex", justifyContent: "center", padding: "2rem" }}>
                                <VideogameAssetIcon style={{ fontSize: "3rem" }} htmlColor="white" />
                            </CardMedia>
                            <CardHeader title="Games" subheader="Play unblocked games" style={{ textAlign: "center" }} />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Card style={{ height: "100%" }}>
                        <CardHeader title="New Games" action={<Button component={Link} to="/games" id="fullscreenEnable" style={{ marginTop: "2px" }} variant="text" startIcon={<SportsEsportsIcon />}> View All Games</Button>} />
                        <CardContent>
                            <Typography color="text.secondary">
                                Feature coming soon!
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Card style={{ height: "100%" }}>
                        <CardHeader title="Coming Soon" subheader="Follow @WakeStudentsWWW on Instagram for updates!" action={<Tooltip title="View our Instagram"><IconButton component="a" target="_blank" href="https://www.instagram.com/wakestudentswww/"><InstagramIcon /></IconButton></Tooltip>} />
                        <CardContent>
                            <Typography color="text.secondary">
                                <ul>
                                    <li>Game how to's</li>
                                    <li>Account system</li>
                                    <li>Ability to favorite games</li>
                                    <li>Retro games</li>
                                    <li>Your game requests!</li>
                                </ul>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}